@for (item of checkboxes; track trackById(i, item); let i = $index) {
  <checkbox-category-list-item [isMainItem]="i < mainItemsNumber" [listitem]="item"></checkbox-category-list-item>
}
